import React, { useState, useEffect } from "react";

export default function DisclaimerPopup({ onAccept }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("troy_disclaimer_accepted");
    if (!accepted) setShow(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("troy_disclaimer_accepted", "true");
    setShow(false);
    if (onAccept) onAccept();
  };

  if (!show) return null;

  return (
    <div className="disclaimer-overlay">
      <div className="disclaimer-box">
        <div className="disclaimer-logo">TROY TRADE</div>
        <div className="disclaimer-sub">Investment Platform by PT. Artemis Bosphora Arthagena</div>

        <div className="disclaimer-body">
          <div className="disclaimer-warning">⚠️ Risk Warning</div>
          <p>Trading leveraged products such as Forex and CFDs carries a <strong>high level of risk</strong> and may not be suitable for all investors. You may lose more than your initial investment.</p>
          <p>By accessing Troy Trade Investment, you confirm that:</p>
          <ul>
            <li>You are at least 18 years of age</li>
            <li>You understand the risks of leveraged trading</li>
            <li>You are not a resident of a restricted jurisdiction</li>
            <li>You have read and agree to our Terms & Conditions</li>
          </ul>
          <p style={{fontSize:"11px", color:"#5A6480", marginTop:"12px"}}>
            PT. Artemis Bosphora Arthagena | Reg. No. 8426105-4 | License HE433420 | House of Francis, Room 302, Ile Du Port, Mahe, Seychelles
          </p>
        </div>

        <div className="disclaimer-btns">
          <button className="btn-main" style={{flex:1}} onClick={handleAccept}>
            I Understand & Accept
          </button>
          <button className="btn-logout" style={{flex:1}} onClick={() => window.location.href = "https://artemisbosphora.com"}>
            Leave Site
          </button>
        </div>
      </div>
    </div>
  );
}